import logo from "../../assets/images/trackerlogo.jpg"
import loading from "../../assets/images/loading.gif"
import { loginTepngUser } from "../../request";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTepngUser } from "../../store/tepngUser";
import { setRoles } from "../../store/roles";
import { useEffect, useState } from 'react';
import { getUserManual } from "helpers";

const Authentication =  () => {
    const isAuthenticated = new URLSearchParams(window.location.search).get("azureauthredirect")
    // alert(isAuthenticated)
    const [isLoading, setIsLoading] = useState(isAuthenticated ? true : false)
    const navigate = useNavigate()   
    const dispatch = useDispatch()

    const redirectUser = (roles: any) => {
        //Redirect user after login        
        const redirectURL = sessionStorage.getItem("redirectURL")
        if(redirectURL !== null) window.location.replace(redirectURL)
        else {
            if(roles?.length > 0) {
                // to avoid thirdparty users from navigating to Supplier page first
                if(roles.find((role: string) => role.toLowerCase() === "freightforwarder")) navigate("/freightforwarder/dashboard")
                else if(roles.find((role: string) => role.toLowerCase() === "localclearingagent")) navigate("/localclearingagent/dashboard")
                else navigate(`/${roles[0].toLowerCase()}/dashboard`)
            }else navigate("/rolelessuser")        
        }
        sessionStorage.removeItem("redirectURL")
    }

    const handleLogin = () => {
        setIsLoading(true)
        loginTepngUser().then((res: any) => {      
            if(res.status) {
                dispatch(setTepngUser(res.userDetails))
                dispatch(setRoles(res.roles))
                if(res.acceptsConsentTerms === false) navigate("/policy")
                else redirectUser(res.roles)
            } 
        })
    }

    useEffect(() => {
        if(isAuthenticated) handleLogin()
        // if(accessToken == null || new Date(accessToken?.expiration) < new Date()) {
        //     const urlParams = new URLSearchParams(window.location.search);
        //     if (urlParams.get("azureauthredirect") === '1') {
        //         TpengLogin()
        //     }else {
        //         RefreshToken(dispatch)
        //             ?.then((res:any) => redirectUser(res.roles))
        //             .catch((error:any) => console.log("error: ",error));
        //     }    
        // } 
        // eslint-disable-next-line
    }, [])

    const handleManualDownload = (type: string) => {
        const link = document.createElement('a');
        link.href = `/media/${getUserManual(type)}`;
        link.target = '_blank';
        link.click();
    };

    return (
        <div className="authentication-container">
            <div className="authentication-modal">
                <div className="inner">
                    <img width="120px" src={logo} alt="" />
                    <h3>Transit Tracker System</h3>   

                    {!isLoading && <div>
                        <button style={{padding: "8px", marginTop: "48px"}} onClick={() => handleLogin()}>Login</button>
                        {/* <span onClick={handleManualDownload} className="mt-2 link-text" style={{fontSize: "11px"}}>Need help with vendor registration or login?</span> */}
                        
                        <hr className="mt-2" style={{border: "1px solid #d9d9d9"}}/>

                        <div className="mt-2" style={{fontSize: "11px"}}>
                            <ul style={{listStyleType: "none", padding: "0"}}>
                                <li style={{marginBottom: "8px"}}>Vendor Registration Manual - <span className="link-text" onClick={() => handleManualDownload("firsttimevendormanual")} style={{textDecoration: "none"}}>📝PDF</span> | <a className="link-text" href="https://youtu.be/vW87LocU27U?si=63ijgqE9l3H1O0G1" target="_blank" rel="noreferrer" style={{textDecoration: "none"}}>🎥Demo Video </a></li>
                                <li style={{marginBottom: "8px"}}>Vendor Register Additional Phone Numbers Manual - <span className="link-text" onClick={() => handleManualDownload("authenticatorappmanual")} style={{textDecoration: "none"}}>📝PDF</span></li>
                                <li style={{marginBottom: "8px"}}>Vendor Login User Guide - <span className="link-text" onClick={() => handleManualDownload("vendorloginmanual")} style={{textDecoration: "none"}}>📝PDF</span> | <a className="link-text" href="https://youtu.be/RK5Fb9zD3Do?si=4IRYI9PAgL9txt_U" target="_blank" rel="noreferrer" style={{textDecoration: "none"}}>🎥Demo Video </a></li>
                            
                            </ul>
                        </div>

                        <hr className="mt-2" style={{border: "1px solid #d9d9d9"}}/>
                        <span className="f-11">Need Help? Contact our support team at <a className="link-text" href="mailto:ep-ng-transittracker-helpdesk@totalenergies.com" target="_blank" rel="noreferrer" style={{textDecoration: "none"}}>ep-ng-transittracker-helpdesk@totalenergies.com</a></span>
                    </div>}
                    {isLoading && <div style={{marginTop: "48px"}}>
                        <img width="60px" src={loading} alt="" />
                        <p className="small-text">Checking your Microsoft AD credentials to access the application</p>
                    </div>}                

                    {/* {!isLoading && <div style={customStyle}>
                        <p className="line-text">Login as</p>
                        <button onClick={() => TpengLogin()}>TotalEnergies Staff</button>
                    </div>} */}
                </div>
            </div>
        </div>
    )
}

export default Authentication